var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home view"},[(_vm.hasRecords)?_c('book-slideshow',{ref:"slideshow",attrs:{"records":_vm.slideshowBooks,"slidesToShow":3}}):_vm._e(),_c('auto-scroller',{attrs:{"active":_vm.autoscroll},on:{"beat":_vm.scroll}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }